import React, { memo } from 'react';
import ReactImageFallback from "react-image-fallback";
import './learnCorner.scss';
import userDefaultImage from "../../assets/images/backend.svg";
import { useSelector } from 'react-redux';
import { useSubjectList } from "examsbook-react-sdk/custom-hooks";

/**
 * Learning corner for web.
 * @param props
 * @returns {*}
 * @constructor
 */
function LearningCorner(props) {
    const { t } = props;
    const appSettings = useSelector((state) => state.appSettings);
    const user = useSelector((state) => state.user);
    const { subjectList } = useSubjectList();

    //hardcoded categories
    const language = user.language;
    let domain = '';
    if (language && appSettings && appSettings.languages) {
        let lang = appSettings.languages.filter((lang) => {
            return lang.code === language;
        });
        if (lang && lang.length > 0) {
            domain = '//' + lang[0].domain;
        }
    }

    function gotoPage(location, inNewTab = true) {
        if (inNewTab) {
            window.open(
                location,
                '_blank'
            );
        } else {
            window.location = location;
        }
    }

    return (
        <div className="exam-board learning-board">
            {
                subjectList && subjectList.length > 0 && <>
                    <div className="exam-heading">
                        <h2>{t('learning_corner')}</h2>
                    </div>
                    <div className="learning-corner-container">
                        {
                            subjectList.map((category, index) => {
                                const slug = 'subjects/' + category.slug;
                                return (
                                    <div className="learning-corner" onClick={() => {
                                        gotoPage(domain + '/' + slug);
                                    }}
                                         key={index}>
                                        <div className="learning-corner-card">
                                            <div className="learn-icon">
                                                <ReactImageFallback
                                                    src={category?.image?.jpgImageUrl}
                                                    fallbackImage={userDefaultImage}
                                                    initialImage={userDefaultImage}
                                                    alt={category.name}
                                                    className="my-image"/>
                                                <h4>{category.name}</h4>
                                                <i className="fa fa-chevron-right"/>
                                            </div>
                                        </div>
                                    </div>
                                );
                            })
                        }
                    </div>
                </>
            }
        </div>
    );
}

function arePropsEqual(prevProps, nextProps) {
    return true;
}

export default memo(LearningCorner, arePropsEqual);
